/* import __COLOCATED_TEMPLATE__ from './filter-group-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
export default Component.extend({
  store: service(),
  appService: service(),
  classNames: ['filter-group', 'flex', 'flex-wrap', 'gap-y-1', 'items-center', 'mb-2'],
  classNameBindings: ['connectionSwitcherHovered:o__connection-switcher-hovered'],
  tagName: 'span',
  mode: 'default',
  isOneLine: true,
  appearance: null,
  connectionSwitcherHovered: false,
  orFilterLimit: 10,
  intl: service(),
  init() {
    this._super(...arguments);
    this.set('logicalSwitcherItems', [{
      text: this.intl.t('users-and-companies.filter-group.and'),
      value: 'and'
    }, {
      text: this.intl.t('users-and-companies.filter-group.or'),
      value: 'or'
    }]);
  },
  predicateGroup: notImplemented('filter-group-editor: You need to pass a predicateGroup to this component'),
  attributeGroupList: notImplemented('filter-group-editor: You need to pass an attributeGroupList to this component'),
  otherPredicatesAreValid: notImplemented('filter-group-editor: You need to pass otherPredicatesAreValid to this component'),
  index: notImplemented('filter-group-editor: You need to pass an index to this component'),
  predicate: notImplemented('filter-group-editor: You need to pass a predicate to this component'),
  predicates: computed('wrapped', function () {
    if (this.wrapped) {
      return this.predicate.predicates;
    } else {
      return [this.predicate];
    }
  }),
  addButtonTooltip: computed('intl.locale', 'predicates.length', function () {
    if (this.predicates.length === 1) {
      return this.intl.t('users-and-companies.filter-group.create-filter-group');
    } else {
      return this.intl.t('users-and-companies.filter-group.add-filter');
    }
  }),
  connectionLabel: readOnly('predicate.type'),
  logicalSwitcherItems: [],
  wrapped: readOnly('predicate.isLogicalType'),
  removePredicate: action(function (predicate) {
    this.set('newlyAddedPredicate', null);
    this.predicateGroup.remove(predicate);
    this.onUpdate({
      action: 'removed'
    });
  }),
  updateTag: action(async function (tagId) {
    let tag = this.store.peekRecord('tag', tagId);
    await tag.reload();
  }),
  handlePredicate: action(async function (predicate) {
    if (predicate['attribute'] === 'manual_tag_ids') {
      try {
        await this.updateTag(predicate['value']);
      } catch (e) {
        // no-op
      }
    }
  }),
  updatePredicate: action(async function (predicate, updatedPredicate) {
    await this.handlePredicate(updatedPredicate);
    predicate.setProperties(updatedPredicate);
    this.onUpdate({
      action: 'edited'
    });
  }),
  switchLogicalMode: action(function () {
    this.predicate.toggleAndOr();
    this.onUpdate({
      action: 'edited'
    });
  }),
  addPredicate: action(function (attribute) {
    this.predicateGroup.add({
      attribute: attribute.identifier,
      type: attribute.type
    }, {
      parentPredicate: this.predicate,
      context: Object.assign({}, this.predicateContext, {
        mode: this.mode
      })
    });
    this.set('newlyAddedPredicate', this.index);
    this.handlePredicate(this.newlyAddedPredicate);
    this.onUpdate({
      action: 'add'
    });
  }),
  predicateIsInvalid: action(function (predicate) {
    if (predicate.selectedTagFailed) {
      return true;
    }
    if (this.supportedPredicateAttributes) {
      return predicate.isInvalid || !this.supportedPredicateAttributes.includes(predicate.attribute);
    } else {
      return predicate.isInvalid;
    }
  }),
  predicateInvalidMessage: action(function (predicate) {
    if (predicate.selectedTagFailed) {
      return predicate.description;
    }
    if (this.supportedPredicateAttributes) {
      if (!this.supportedPredicateAttributes.includes(predicate.attribute)) {
        return 'is not supported';
      } else if (predicate.isInvalid) {
        return 'is missing value';
      }
    } else {
      return predicate.isInvalid ? 'is missing value' : undefined;
    }
  }),
  predicateAttributeDescription: action(function (predicate) {
    if (predicate.selectedTagFailed) {
      return this.intl.t('users-and-companies.filter-block-editor.manual-tag-failed');
    }
    return predicate.attributeDescription;
  })
});